import { useEffect, useRef, useState } from 'react';

interface InstallCmdProps {
  cmd: string;
}

export function InstallCmd({ cmd }: InstallCmdProps) {
  const [copied, setCopied] = useState(false);
  const resetRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (resetRef.current) clearTimeout(resetRef.current);
    };
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(cmd).then(() => {
      setCopied(true);
      resetRef.current = setTimeout(() => setCopied(false), 2000);
    }).catch(() => {});
  };

  return (
    <div className="flex items-center gap-2 rounded bg-background px-3 py-2 text-sm font-mono overflow-x-auto">
      <code className="flex-1 text-secondary truncate">{cmd}</code>
      <button
        onClick={handleCopy}
        aria-label="Copy install command"
        className="shrink-0 rounded px-2 py-0.5 text-xs bg-surface text-white hover:bg-card transition-colors"
      >
        {copied ? 'Copied!' : 'Copy'}
      </button>
    </div>
  );
}
